module.exports = new __parcel__URL__("create-form-background-light.b4049e52.png").toString();